<template>
  <div class="reports">
    <MobileTable
      v-model:selection="store.state.report.selectedReports"
      label="Listado de Reportes Señalados"
      :columns="report.columns"
      :data="store.state.report.reports"
    />
    <DesktopTable
      v-model:selection="store.state.report.selectedReports"
      label="Listado de Reportes Señalados"
      :columns="report.columns"
      :data="store.state.report.reports"
    />
    <Actions :items="report.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/reportes/nuevo");
    };
    const onChange = async (id) => {
      if (store.state.report.selectedReports.length !== 1) {
        store.state.toast.add({
          severity: "info",
          summary: "",
          detail: "Debe seleccionar un registro!",
          life: 5000,
        });
      } else {
        store.commit("setLoading", true);

        const response = await store.dispatch(actions.reportActions.status, {
          statusId: id,
          id: store.state.report.selectedReports[0].id,
        });

        if (response.ok) {
          store.commit("setSelectedReports", []);
          await store.dispatch(
            actions.reportActions.findAll,
            store.state.general.selectedBuilding
          );
          store.commit("setLoading", false);
        } else {
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
          store.commit("setLoading", false);
        }
      }
    };

    const report = reactive({
      columns: [
        {
          field: "id",
          header: "Número",
          sort: true,
          center: true,
        },
        {
          field: "title",
          header: "Título",
          sort: true,
        },
        {
          field: "description",
          header: "Descripción",
          sort: true,
        },
        {
          field: "date",
          header: "Fecha de Registro",
          sort: true,
          date: true,
        },
        {
          field: "user",
          header: "Hecho por",
          sort: true,
        },
        {
          field: "indDoc",
          header: "Adjunto",
          center: true,
        },
        {
          field: "status",
          header: "Estado",
          sort: true,
          center: true,
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/reportes/nuevo"),
        },
        {
          name: "En Proceso",
          action: () => onChange(2),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/reportes/nuevo"),
        },
        {
          name: "Listo",
          action: () => onChange(4),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/reportes/nuevo"),
        },
        {
          name: "Rechazado",
          action: () => onChange(3),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/reportes/nuevo"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedReports", []);
      const finded = store.state.general.breadcrumbs.find(
        (item) => item.to === route.path
      );
      if (!finded)
        store.commit("addBreadcrumb", { label: route.name, to: route.path });
      await store.dispatch(
        actions.reportActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    return { store, report };
  },
};
</script>

<style scoped></style>
